import { defineKey as T } from '@ha/intl';

export const STATE_NAME = 'payoutsPaymentRequests';
export const PAYMENT_REQUESTS_PER_PAGE = 10;

export const alertMessages = {
  pr_cancel_success: T('Payment request has been canceled'),
  pr_cancel_error: T('Payment request could not be canceled'),
};
